/**
 * @desc 获取仓库sku库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(params: API.stock.stockSku.getStockSku.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/sku`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
